/**
 * Атрибути ролі tabpanel для панелі вмісту під смугою вкладок (UIUX controls/tabs, WAI-ARIA tabs): id `<основа>-panel`, підпис — активна
 * вкладка `<основа>-tab-<ключ>`; панель фокусується з клавіатури (tabIndex 0). Чиста функція.
 */
export function tabPanelProps(idBase: string, active: string): { role: 'tabpanel'; id: string; 'aria-labelledby': string; tabIndex: number } {
  return { role: 'tabpanel', id: `${idBase}-panel`, 'aria-labelledby': `${idBase}-tab-${active}`, tabIndex: 0 };
}
